export default class newpackageManager {
    constructor(effect) {
        this.$hover;
        this.$bg;

        // ページ別でホバー解除の時の動作を制御するため、ページ名を取得
        this.$pageBody = document.getElementsByTagName('body');
        this.$pageName = this.$pageBody[0].id;

        this.effect = effect;
    }
    init(){
        this.$hover = document.getElementsByClassName("js__i-hover");
        this.$bg = document.getElementsByClassName("js__i-bg-hover");

        for(let i = 0; i < this.$hover.length; i++) {
            this.$hover[i].addEventListener("mouseenter", () => {
                this.mouseEnter(i);
            });
            this.$hover[i].addEventListener("mouseleave", () => {
                this.mouseLeave(i);
            });
        }

        this.effect.scale(document.querySelectorAll(".js__sp-scale"),"set");
        this.effect.svg(document.getElementById("p-kv-copy"),"set");
        this.effect.svg(document.getElementById("p-kv-copy-sp"),"set");
        this.effect.splitText(document.querySelectorAll(".js__sp-split"),"set");

        setTimeout(()=>{
            this.effect.svg(document.querySelectorAll(".js__sp-svg")[0],"show");
            this.effect.svg(document.querySelectorAll(".js__sp-newpackage-svg")[0],"show");
            this.effect.panel(document.querySelectorAll(".js__sp-image-mask"),"show");
            this.effect.scale(document.querySelectorAll(".js__sp-scale"),"show");

            setTimeout(()=>{
                this.effect.splitText(document.querySelectorAll("#p-kv-text >* >*"),"show");
            },1e3)
        },3e2)
    }
    mouseEnter(index) {
        // 背景の拡大
        TweenMax.to(this.$bg[index], 1, {
            scale : 1.1
        });
    }
    mouseLeave(index) {
        TweenMax.to(this.$bg[index], .4, {
            scale : 1
        });
    }
}